export default __webpack_public_path__ + "static/media/springSecurity.459e3fff.png";